import client from "@/api/openapi-ts";
import { defineStore, acceptHMRUpdate } from "pinia";
import { computed, ref } from "vue";

type Theme = {
  id: number;
  name: string;
  display_name: string;
  default: boolean;
};

export const useThemeStore = defineStore("theme", () => {
  const activeTheme = ref<Theme>();
  const loading = ref(false);
  const themes = ref<Theme[]>();

  const brand = computed(() => {
    return activeTheme.value?.name === "deeproot" ? "Deep Root" : "Tunnl";
  });

  return {
    activeTheme,
    loading,
    themes,
    brand,

    async index() {
      loading.value = true;
      try {
        const { data } = await client.GET("/api/v1/themes");
        themes.value = (data as unknown as Theme[]) ?? [];
      } catch (error) {
        console.error(error);
      } finally {
        loading.value = false;
      }
    },
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useThemeStore, import.meta.hot));
}
